class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('button[type="button"]');
    this.savedScrollY = 0;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    details.hasAttribute('open') ? this.close() : this.open(details);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(details) {
    // Save scroll position before layout shifts
    // if (typeof lenis !== 'undefined') {
    //   this.savedScrollY = lenis.scroll;
    //   lenis.stop();
    // }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.documentElement.classList.add('modal-open'); // ✅ Use <html> not <body>

    requestAnimationFrame(() => {
      details.setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);

      const focusEl = this.detailsContainer.querySelector('input:not([type="hidden"])');
      if (focusEl) focusEl.focus({ preventScroll: true });

      // if (typeof lenis !== 'undefined') {
      //   setTimeout(() => {
      //     lenis.scrollTo(this.savedScrollY, { immediate: true });
      //   }, 50);
      // }
    });
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.documentElement.classList.remove('modal-open'); // ✅ Remove from <html>

    // if (typeof lenis !== 'undefined') {
    //   lenis.start();
    //   setTimeout(() => {
    //     lenis.scrollTo(this.savedScrollY, { immediate: true });
    //   }, 50);
    // }

    if (focusToggle && this.summaryToggle) {
      this.summaryToggle.focus({ preventScroll: true });
    }
  }
}

customElements.define('details-modal', DetailsModal);
